import './style.css';

function RedButton({ buttonText, buttonWidth, buttonBorder }) {
  return (
    <>
      <input type='button' className='red-button' value={buttonText} style={{ width: buttonWidth, border: buttonBorder }} />
    </>
  );
}

export default RedButton;
